import React from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { ArrowBack, Restaurant, Share, AccountCircle } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { goBackInApp } from '../../utils/navigation';
import { IconButton } from '../ui/ConvivialComponents';

export default function TopAppBar({
  title = 'ConvivialApp.it',
  variant = 'back',
  showAvatar = true,
  avatar,
  onShare,
  titleAction,
  rightAction,
  sticky = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const userAvatar = avatar || localStorage.getItem('user_avatar_url') || '';
  const userId = localStorage.getItem('user_id');
  const openProfile = () => {
    if (userId) navigate(`/user/${userId}`);
  };

  return (
    <Box
      component="header"
      sx={{
        position: sticky ? 'sticky' : 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        height: 'var(--cv-top-bar-height)',
        pt: 'var(--cv-safe-area-top)',
        bgcolor: 'rgba(252, 249, 245, 0.92)',
        backdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(223, 191, 193, 0.28)',
        boxShadow: '0 2px 12px rgba(29, 29, 27, 0.04)',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: '100%', width: '100%', maxWidth: 1200, mx: 'auto', px: { xs: 1.5, sm: 3 }, gap: 1 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            minWidth: 0,
            width: '100%',
          }}
        >
          {variant === 'back' && location.pathname !== '/index' && location.pathname !== '/' && (
            <IconButton label="Indietro" onClick={() => goBackInApp(navigate)}>
              <ArrowBack />
            </IconButton>
          )}
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              minWidth: 0,
              flexShrink: 1,
            }}
          >
            <Restaurant sx={{ color: 'primary.main', display: { xs: 'none', sm: 'block' } }} />
            <Typography variant="h3" sx={{ color: 'primary.main', fontWeight: 700, fontSize: { xs: 18, sm: 24 }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {title}
            </Typography>
          </Stack>
          {titleAction && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                ml: 'auto',
                flexShrink: 0,
              }}
            >
              {titleAction}
            </Box>
          )}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {onShare && (
            <IconButton label="Condividi" onClick={onShare}>
              <Share />
            </IconButton>
          )}
          {rightAction}
          {!titleAction && showAvatar && (
            userAvatar ? (
              <Avatar
                src={userAvatar}
                alt="Profilo"
                onClick={openProfile}
                sx={{ width: 38, height: 38, border: '2px solid #8a0030', cursor: userId ? 'pointer' : 'default' }}
              />
            ) : (
              <IconButton label="Profilo" onClick={openProfile} disabled={!userId}>
                <AccountCircle sx={{ color: 'text.secondary', fontSize: 36 }} />
              </IconButton>
            )
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
